export default __webpack_public_path__ + "static/media/listing-05.3145d680.jpg";